import { render, staticRenderFns } from "./Economica.vue?vue&type=template&id=f725d4a4&scoped=true"
import script from "./Economica.vue?vue&type=script&lang=js"
export * from "./Economica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f725d4a4",
  null
  
)

export default component.exports